var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7609 20.0537C27.7609 15.7752 24.2799 12.2944 20.001 12.2944C9.70649 12.7207 9.70946 27.3882 20.0011 27.8129C24.2799 27.8129 27.7609 24.3321 27.7609 20.0537ZM20.001 24.8207C17.3723 24.8207 15.2337 22.6822 15.2337 20.0537C15.4956 13.7296 24.5075 13.7315 24.7683 20.0537C24.7684 22.6822 22.6298 24.8207 20.001 24.8207Z",
    fill: "#F44380"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8919 19.5606C38.7318 17.0024 33.0636 5.98399 21.1788 5.19019V10.0049C25.8178 10.5455 29.5085 14.2357 30.0495 18.8743H34.9877C36.5807 18.9324 36.602 21.1574 35.021 21.2327H30.0494C29.5085 25.8713 25.8177 29.5614 21.1787 30.102V34.9381C33.075 34.3443 38.7223 23.1878 39.8959 20.5464C40.0358 20.2321 40.034 19.874 39.8919 19.5606Z",
    fill: "#F44380"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 17.645C18.6724 17.645 17.5918 18.7255 17.5918 20.0536C17.7241 23.249 22.2778 23.248 22.4096 20.0536C22.4096 18.7255 21.329 17.645 20.0007 17.645Z",
    fill: "#F44380"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95146 21.2328H5.01382C3.42075 21.1747 3.3995 18.9497 4.98054 18.8744H9.95154C10.4925 14.2363 14.1826 10.5463 18.8208 10.0051V5.16968C6.92547 5.76427 1.27747 16.9199 0.103602 19.5613C-0.0361583 19.8757 -0.0342833 20.2338 0.107821 20.5472C1.26817 23.1054 6.93688 34.123 18.8208 34.9175V30.1019C14.1825 29.5609 10.4924 25.8709 9.95146 21.2328Z",
    fill: "#F44380"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1796 5.19024V2.03504C21.1173 0.470483 18.883 0.471654 18.8213 2.03504V5.16961C19.5942 5.13001 20.4133 5.13836 21.1796 5.19024Z",
    fill: "#F44380"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8203 34.9175V37.9652C18.8827 39.5297 21.1169 39.5286 21.1787 37.9652V34.9383C20.4056 34.9778 19.5867 34.9694 18.8203 34.9175Z",
    fill: "#F44380"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTarget);
export default __webpack_public_path__ + "static/media/icon_target.b029df3a3094659cc02be35898bcc253.svg";
export { ForwardRef as ReactComponent };